"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessStreams = void 0;
var BusinessStreams;
(function (BusinessStreams) {
    BusinessStreams["OCR"] = "OCR";
    BusinessStreams["INTERNATIONAL"] = "International";
    BusinessStreams["ENGLISH"] = "English";
    BusinessStreams["CEM"] = "CEM";
    BusinessStreams["ACADEMIC"] = "Academic";
    BusinessStreams["EDUCATION"] = "Education";
    BusinessStreams["ELT"] = "ELT";
})(BusinessStreams = exports.BusinessStreams || (exports.BusinessStreams = {}));
